<template lang="pug">

transition(
  @enter="enter" 
  @leave="leave"
  )
  #loading  

</template>

<script>

import gsap from 'gsap' 
import { mapState, mapMutations } from 'vuex' 
import AssetService from 'src/services/AssetService'
import GLTFService from 'src/services/GLTFService' 
import { PATHS, LOAD } from 'src/config/app'
import Env from 'src/config/env'

export default {

  name: PATHS.LOADING,
  
  components: {  },
  
  data() {
    return {
      showBackground: true,
      progress: {
        assets: 0,
        media: 0,
        sounds: 0,
        gltf: 0
      },
      startTime: Date.now(),
      updateTime: 100,
      minTime: 1000,
    }
  },

  computed: {
    ...mapState('app', [
      'loading', 
      'debug', 
      'route',
      'landingCopy'
    ]),

    landingCopy(){ 
      let prompt = Env.touch_device ? 'Swipe up' : 'Scroll down'
      return `${prompt} ${this.lang_en['home-welcome-copy']}` 
    }
  },

  mounted() {
    if (this.debug) this.minTime = 0

 
    AssetService.on(AssetService.Events.PROGRESS, this.onAssetsProgress)
    GLTFService.on(GLTFService.Events.PROGRESS, this.onGltfProgress) 
    this.interval = setInterval(this.update)
  },

  beforeDestroy() {
    AssetService.off(AssetService.Events.PROGRESS, this.onAssetsProgress)
    GLTFService.off(GLTFService.Events.PROGRESS, this.onGltfProgress) 
    clearInterval(this.interval)
  },

  watch: {
    'loading.state'(val){
      if(val === LOAD.STATES.COMPLETE){
        this.next()
      } else if(val === LOAD.STATES.BUBBLE_LOADED){
        this.showBackground = false
      }
    }
  },

  methods: {
    
    ...mapMutations('app', ['setLoadProgress' , 'setLoadingCopy']),
    
    onAssetsProgress(data) {
      this.progress.assets = data
    },
    
    onGltfProgress(data) {
      this.progress.gltf = data
    },
   
    // onMediaProgress(data) {
    //   this.progress.media = data
    // },
   
    // onSoundsProgress(data) {
    //   this.progress.sounds = data
    // },
    update() {
      let actualProgress = 0
      let loaders = 2 // 3
      actualProgress += this.progress.assets / loaders
      actualProgress += this.progress.gltf / loaders  
      this.setLoadProgress(actualProgress)  
    },

    enter(el, done){
      done()
    },

    leave(el, done){ 
      done()
    },

    next() {
 
      clearInterval(this.interval)
      this.setLoadProgress(1)

      // on delay so you see 100% 
      this.$router.replace(this.route.afterLoad) 
    },
  },
}
</script>

<style lang="sass">
@import "src/styles/common.sass"

#loading
  +full()
  +flex-center()

 

</style>
